export const HEAD_HEIGHT = 60;
export const DESKTOP_HEAD_HEIGHT = 124;

export const FOOTER_HEIGHT = 80;
export const DESKTOP_FOOTER_HEIGHT = 110;

// TODO this is mock
export const phoneNumbers = [
  '(050) 000 00 00',
  '(050) 111 00 01',
  '(050) 222 00 02',
];

export const SLIDER_ID = 'sliderWithGallery';

export const GALLERY_ROOT_STYLES = {
  height: `calc(100dvh - ${HEAD_HEIGHT}px - ${FOOTER_HEIGHT}px)`,
  top: HEAD_HEIGHT,
  zIndex: 10100,
  '--yarl__container_background_color': 'transparent',
  '--yarl__color_backdrop': 'transparent',
};

export const GALLERY_DESKTOP_ROOT_STYLES = {
  ...GALLERY_ROOT_STYLES,
  height: `calc(100dvh - ${DESKTOP_HEAD_HEIGHT}px - ${DESKTOP_FOOTER_HEIGHT}px)`,
  top: DESKTOP_HEAD_HEIGHT,
};
